import styles from './customer-details-grid-renderer.module.scss';
import { useState } from 'react';
import { booleanHeader, Box, CreateHeaders, HeaderSizeEnum, Icon, PrimaryButton, SecondaryButton, textHeader } from '@frontend-workspace/react-shared-lib';
import AssignLicenseRightsDialog from '../assign-license-rights-dialog/assign-license-rights-dialog';
import { ICompanyUserLicenses } from '../../_models/company-user-accounts';
import WebkuaTable from '../../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CustomerDetailsGridRendererProps { }

export function CustomerDetailsGridRenderer(props: any) {
  const { t } = useTranslation();
  const [assignLicenseRights, setAssignLicenseRights] = useState<boolean>(false);
  const [assignDemoLicenseRights, setAssignDemoLicenseRights] = useState<boolean>(false);
  const licenses: ICompanyUserLicenses[] = props.data.licenses;

  const openAssignLicenseRightsDialog = () => setAssignLicenseRights(true);
  const openAssignDemoLicenseRightsDialog = () => setAssignDemoLicenseRights(true);
  const closeAssignLicenseRightsDialog = () => setAssignLicenseRights(false);
  const closeAssignDemoLicenseRightsDialog = () => setAssignDemoLicenseRights(false);

  const headers = CreateHeaders([
    textHeader("licenseNumber", t('standard.licenseNumber'), HeaderSizeEnum.MEDIUM),
    textHeader("productName", t('standard.productName'), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("contractNumber", t('standard.contractNo'), HeaderSizeEnum.MEDIUM),
    textHeader("typeName", t('standard.type'), HeaderSizeEnum.SMALL),
    booleanHeader("hasDomainAccess", t('standard.domainAccess')),
    booleanHeader("hasAccess", t('standard.access')),
    booleanHeader("isCoordinator", t('standard.licensingCoordinator'))
  ]);

  return <>
    <Box className="d-flex flex-column py-4 px-2">
      <div className="mb-3 mb-sm-0">
        <PrimaryButton
          variant="contained"
          size='small'
          onClick={openAssignLicenseRightsDialog}>
          <Icon className="me-1" fontSize="small">add</Icon>{t('standard.assignLicenseRights')}
        </PrimaryButton>
        <PrimaryButton
          variant="contained"
          className='ms-2'
          size='small'
          onClick={openAssignDemoLicenseRightsDialog}>
          <Icon className="me-1" fontSize="small">add</Icon>{t('standard.assignDemoLicenseRights')}
        </PrimaryButton>
      </div>
      <WebkuaTable
        headers={headers}
        data={licenses}
      />
    </Box>
    {assignLicenseRights && <AssignLicenseRightsDialog
      open={!!assignLicenseRights}
      onClose={closeAssignLicenseRightsDialog}
      email={props.data.email}
    />}
    {assignDemoLicenseRights && <AssignLicenseRightsDialog
      open={!!assignDemoLicenseRights}
      onClose={closeAssignDemoLicenseRightsDialog}
      email={props.data.email}
      isTrial={true}
    />}
  </>
}

export default CustomerDetailsGridRenderer;